import Actions from '.';
import { get } from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const getNotifications = () => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/notifications`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                list: data.response || [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            list: []
        }));
    }
});

export default {
    getNotifications
}